export default __webpack_public_path__ + "static/media/BAFS.9173d656.png";